import React, { FunctionComponent } from 'react'
import { formatTimestamp, getTimeDifferenceInMinutes } from '../../../utils/time'
import { Tooltip, Typography } from 'antd'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useQuery } from '@tanstack/react-query'

interface IProps {
  vehicleId: number
}

const VehicleLocationUpdateTime: FunctionComponent<any> = (props: IProps) => {
  const { vehicleId } = props

  const client = useFeathersClient()

  const { data: vehicleLocation } = useQuery({
    queryKey: ['vehicle-location', 'find', vehicleId],
    queryFn: () =>
      client.service('vehicle-location').find({
        query: {
          vehicle_id: vehicleId
        }
      }).then((res: any) => res.data[0]),
    enabled: !!vehicleId,
    refetchInterval: 5000
  })

  const timeDifference = getTimeDifferenceInMinutes(vehicleLocation?.update_time)

  const getColor = (timeDifferenceInMinutes: number) => {
    if (timeDifferenceInMinutes < 5) {
      return 'green'
    } else if (timeDifferenceInMinutes < 10) {
      return 'orange'
    } else {
      return 'red'
    }
  }

  return (
    <Tooltip title={formatTimestamp(vehicleLocation?.update_time)}>
      <Typography.Text style={{ color: getColor(timeDifference) }} ellipsis={true}>
        {formatTimestamp(vehicleLocation?.update_received, 'MM/DD h:mm a')}
      </Typography.Text>
    </Tooltip>
  )
}

export default VehicleLocationUpdateTime
